import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEventsLog } from 'modules/eventsLog/selectors';
import { selectIsUuidBasedProject } from 'core/userContext';
import { PageHeader } from 'ui/pageHeader';
import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { InputText } from 'ui/inputs/inputText';
import { FlexSpacer } from 'ui/flexSpacer';
import { fetchEventsLogRequest } from '../actions';
import { configureTableColumns, eventsLogFilterFn } from '../utils';

export const EventsLog = () => {
  const dispatch = useDispatch();
  const eventsLog = useSelector(selectEventsLog);
  const isUuidBased = useSelector(selectIsUuidBasedProject);

  const COLUMNS = useMemo(() => configureTableColumns(isUuidBased), [isUuidBased]);

  const {
    currentPage,
    filter,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setFilter,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: eventsLog,
    sortedBy: 'createdAt',
    filterFn: eventsLogFilterFn,
  });

  useEffect(() => {
    dispatch(fetchEventsLogRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        documentation={{
          href: 'http://support.iterable.com/hc/en-us/articles/205614175-Events-Overview',
          content: 'Documentation',
        }}
        pageActions={
          <InputText
            data-test="filter-enabled-accounts"
            value={filter}
            onChange={setFilter}
            placeholder={'Filter by...'}
          />
        }
        pageSubSection={<div>Showing the 250 most recent events.</div>}
      >
        Events log
      </PageHeader>
      <Table>
        <TableHeader
          columns={COLUMNS}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy}
        />
        {rows.length > 0 && <TableRows columns={COLUMNS} rows={rows} />}
      </Table>
      {rows.length === 0 && (
        <FlexSpacer padding="cardPadding" justifyContent="center">
          No events found
        </FlexSpacer>
      )}
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};
